var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-progress',{attrs:{"label":_vm.label,"sort":_vm.sort,"value":_vm.counter.Count,"required":_vm.counter.RequiredCount}},[(_vm.display.filesDebug.state)?_c('div',[_c('ul',_vm._l((_vm.counter),function(value,key){return _c('li',{key:key},[_c('strong',[_vm._v(_vm._s(key)+":")]),_vm._v(" "+_vm._s(value))])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }